import React from 'react';
import PropTypes from 'prop-types';
import './_styles_/ReadonlyList.css';
import { joinClassNames } from '../../utils';

ReadonlyList.propTypes = {
    keepPosition: PropTypes.bool,
    label: PropTypes.node.isRequired,
    values: PropTypes.arrayOf(PropTypes.node).isRequired,
    className: PropTypes.string,
};

ReadonlyList.defaultProps = {
    keepPosition: false,
    className: '',
};

function ReadonlyList(props) {
    const {
        keepPosition,
        label,
        values,
        className,
    } = props;
    return (
        <div className={joinClassNames('readonly-list', 'field', 'readonly', className, keepPosition && 'keep-position')}>
            <span className="field--key">{label}</span>
            <div className="field--value">
                {values.length > 0 && (
                    <ul className="readonly-list--value-list">
                        {values.map((value) => <li key={value}>{value}</li>)}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default ReadonlyList;
